module.exports = __webpack_public_path__ + "media/images/mastercard-b720e3b5a9bf9bce7ef42d6682f56356.svg";